import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Box,
  Button,
  Grid,
  InputAdornment,
  InputLabel,
  makeStyles,
  TextField,
  CircularProgress,
  IconButton,
  useTheme,
  useMediaQuery
} from '@material-ui/core';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { green } from '@material-ui/core/colors';
import { STATUS_API } from 'src/app/constant/config';
import * as Yup from 'yup';
import { Formik } from 'formik';
import { getListProvinces } from 'src/features/provinceSlice';
import { getListAgencies } from 'src/features/agencySlice';
import { roles, roleUsers } from 'src/app/constant/roles';
import { createUser } from 'src/features/userSlice';
import { createCustomer } from 'src/features/customerSlice';
import CustomDialog from 'src/app/components/CustomDialog';
import Autocomplete from '@material-ui/lab/Autocomplete';
import {
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl
} from '@material-ui/core';
import { getListAgencyBusiness } from 'src/features/agencySlice';

const initStateFromValue = {
  username: '',
  full_name: '',
  email: '',
  phone: '',
  address: '',
  password: '',
  confirm_password: '',
  citizen_id: '',
  role: '6',
  tax_code: '',
  business_id: '',
  type: 'user'
};

function CreateUser({ open, onClose }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const { statusCreate: statusCreateUser } = useSelector(
    state => state.userSlice
  );
  const { statusCreate: statusCreateCustomer } = useSelector(
    state => state.customerSlice
  );
  const statusCreate =
    statusCreateUser === STATUS_API.PENDING ||
      statusCreateCustomer === STATUS_API.PENDING
      ? STATUS_API.PENDING
      : statusCreateUser === STATUS_API.SUCCESS ||
        statusCreateCustomer === STATUS_API.SUCCESS
        ? STATUS_API.SUCCESS
        : statusCreateUser === STATUS_API.ERROR ||
          statusCreateCustomer === STATUS_API.ERROR
          ? STATUS_API.ERROR
          : null;

  const listProvinces = useSelector(state => state.provinceSlice.listProvinces);
  const dataLogin = useSelector(state => state.authSlice.dataLogin);
  const isAdmin =
    dataLogin && dataLogin.role && dataLogin.role.title === roles.ADMIN;
  const listAgencyBusiness = useSelector(
    state => state.agencySlice.listAgencyBusiness
  );

  const [initValue, setInitValue] = useState(initStateFromValue);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const handleSubmit = data => {
    if (isAdmin && data.type === 'user') {
      const newUser = {
        username: data.username ? data.username : null,
        full_name: data.full_name,
        email: data.email ? data.email : 'example@gmail.com',
        phone: data.phone,
        password: data.password,
        confirm_password: data.confirm_password,
        address: data.address,
        citizen_id: data.citizen_id,
        role: 6
      };
      setInitValue(data);
      dispatch(createUser(newUser));
    } else {
      const newCustomer = {
        username: data.username ? data.username : null,
        tax_code: data.tax_code ? data.tax_code : null,
        full_name: data.full_name,
        address: data.address ? data.address : null,
        phone: data.phone,
        email: data.email ? data.email : null,
        business_id: data.business_id ? data.business_id : null,
        province_id: data.citizen_id ? data.citizen_id : null,
        password: data.password
      };
      setInitValue(data);
      dispatch(createCustomer(newCustomer));
    }
    onClose();
  };

  const handleClose = () => {
    onClose();
    setInitValue(initStateFromValue);
  };

  useEffect(() => {
    dispatch(getListProvinces());
    dispatch(getListAgencyBusiness());
    if (isAdmin) dispatch(getListAgencies());
  }, [isAdmin]);

  return (
    <CustomDialog title="Thêm mới khách hàng" open={open} onClose={handleClose}>
      <div>
        <Formik
          initialValues={initValue}
          validationSchema={Yup.object().shape({
            username: Yup.string()
              .max(100)
              .matches(/^\S+$/, 'Tên đăng nhập không được chứa khoảng trắng')
              .matches(
                /^[a-zA-Z0-9_]+$/,
                'Tên đăng nhập không được chứa ký tự đặc biệt'
              ),
            full_name: Yup.string()
              .max(100)
              .required(values =>
                values?.type === 'user' ? 'Tên người dùng không được để trống' : 'Tên khách hàng không được để trống'
              ),
            email: Yup.string().email('Email chưa đúng định dạng'),
            phone: Yup.string()
              .matches(
                /^(84|0[3|5|7|8|9])+([0-9]{8})$/,
                'Số điện thoại chưa đúng định dạng'
              )
              .required('Số điện thoại không được để trống'),
            address: Yup.string().max(100),
            citizen_id: Yup.string()
              .max(100)
              .required('Tỉnh thành không được để trống'),
            password: Yup.string()
              .max(100)
              .required('Mật khẩu không được để trống'),
            confirm_password: Yup.string()
              .oneOf([Yup.ref('password'), null], 'Mật khẩu chưa khớp')
              .required('Xác nhận lại mật khẩu')
          })}
          onSubmit={handleSubmit}
        >
          {({
            errors,
            handleBlur,
            handleChange,
            handleSubmit,
            setFieldValue,
            touched,
            values
          }) => (
            <form onSubmit={handleSubmit}>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <FormControl component="fieldset">
                    <RadioGroup
                      row
                      name="type"
                      value={values.type}
                      onChange={handleChange}
                    >
                      <FormControlLabel
                        value="user"
                        control={<Radio color="primary" />}
                        label="Khách lẻ"
                      />
                      <FormControlLabel
                        value="agency"
                        control={<Radio color="primary" />}
                        label="Doanh nghiệp"
                      />
                    </RadioGroup>
                  </FormControl>
                </Grid>
                <Grid item md={6} xs={12}>
                  <InputLabel>
                    Tên khách hàng<span style={{ color: 'red' }}> *</span>
                  </InputLabel>
                  <TextField
                    error={Boolean(touched.full_name && errors.full_name)}
                    className="input-no-fieldset"
                    fullWidth
                    helperText={touched.full_name && errors.full_name}
                    margin="normal"
                    name="full_name"
                    size="small"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.full_name}
                    placeholder="Nhập tên khách hàng"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start"></InputAdornment>
                      )
                    }}
                    variant="outlined"
                  />
                </Grid>
                <Grid item md={6} xs={12}>
                  <InputLabel>
                    Số điện thoại <span style={{ color: 'red' }}> *</span>
                  </InputLabel>
                  <TextField
                    error={Boolean(touched.phone && errors.phone)}
                    className="input-no-fieldset"
                    fullWidth
                    helperText={touched.phone && errors.phone}
                    margin="normal"
                    name="phone"
                    size="small"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.phone}
                    placeholder="Nhập số điện thoại"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start"></InputAdornment>
                      )
                    }}
                    variant="outlined"
                  />
                </Grid>
                <Grid item md={6} xs={12}>
                  <InputLabel>
                    Tên đăng nhập<span style={{ color: 'red' }}></span>
                  </InputLabel>
                  <TextField
                    error={Boolean(touched.username && errors.username)}
                    className="input-no-fieldset"
                    fullWidth
                    helperText={touched.username && errors.username}
                    margin="normal"
                    name="username"
                    size="small"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.username}
                    placeholder="Nhập tên đăng nhập"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start"></InputAdornment>
                      )
                    }}
                    variant="outlined"
                  />
                </Grid>
                <Grid item md={6} xs={12}>
                  <InputLabel style={{ marginBottom: '21px' }}>
                    Tỉnh thành <span className="text-danger">*</span>
                  </InputLabel>
                  <Autocomplete
                    labelId="demo-simple-select-outlined-label"
                    id="demo-simple-select-outlined"
                    size="small"
                    options={listProvinces || []}
                    getOptionLabel={option => option.name || ''}
                    value={(listProvinces || []).find(
                      option => String(option.id) === String(values.citizen_id)
                    ) || null}
                    onChange={(e, value) =>
                      setFieldValue('citizen_id', value ? String(value.id) : '')
                    }
                    onBlur={handleBlur}
                    renderInput={params => (
                      <TextField
                        {...params}
                        variant="outlined"
                        placeholder="Chọn tỉnh thành"
                        name="citizen_id"
                        error={Boolean(
                          touched.citizen_id && errors.citizen_id
                        )}
                        helperText={touched.citizen_id && errors.citizen_id}
                        InputProps={{
                          ...params.InputProps,
                          style: {
                            fontSize: '16px',
                            padding: '0 8px',
                            height: '35px'
                          }
                        }}
                      />
                    )}
                  />
                </Grid>
                <Grid item md={6} xs={12}>
                  <InputLabel>
                    Địa chỉ<span style={{ color: 'red' }}></span>
                  </InputLabel>
                  <TextField
                    error={Boolean(touched.address && errors.address)}
                    className="input-no-fieldset"
                    fullWidth
                    helperText={touched.address && errors.address}
                    margin="normal"
                    name="address"
                    size="small"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.address}
                    placeholder="Nhập địa chỉ"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start"></InputAdornment>
                      )
                    }}
                    variant="outlined"
                  />
                </Grid>
                <Grid item md={6} xs={12}>
                  <InputLabel>
                    Email <span style={{ color: 'red' }}></span>
                  </InputLabel>
                  <TextField
                    error={Boolean(touched.email && errors.email)}
                    fullWidth
                    helperText={touched.email && errors.email}
                    margin="normal"
                    className="input-no-fieldset"
                    name="email"
                    size="small"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.email}
                    placeholder="Nhập email"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start"></InputAdornment>
                      )
                    }}
                    variant="outlined"
                  />
                </Grid>
                {values.type === 'agency' && (
                  <>
                    <Grid item md={6} xs={12}>
                      <InputLabel style={{ marginBottom: '21px' }}>
                        Loại hình kinh doanh <span style={{ color: 'red' }}></span>{' '}
                      </InputLabel>
                      <Autocomplete
                        size="small"
                        options={listAgencyBusiness || []}
                        getOptionLabel={option => option.title || ''}
                        value={(listAgencyBusiness || []).find(
                          option => option.id === values.business_id
                        ) || null}
                        onChange={(e, value) =>
                          setFieldValue('business_id', value ? value.id : '')
                        }
                        renderInput={params => (
                          <TextField
                            {...params}
                            variant="outlined"
                            placeholder="Chọn loại hình kinh doanh"
                            name="business_id"
                            error={Boolean(
                              touched.business_id && errors.business_id
                            )}
                            helperText={
                              touched.business_id && errors.business_id
                            }
                            InputProps={{
                              ...params.InputProps,
                              style: {
                                fontSize: '16px',
                                padding: '0 8px',
                                height: '35px'
                              }
                            }}
                          />
                        )}
                        className={classes.customOutline}
                      />
                    </Grid>
                    <Grid item md={6} xs={12}>
                      <InputLabel>
                        Mã số thuế <span style={{ color: 'red' }}></span>{' '}
                      </InputLabel>
                      <TextField
                        error={Boolean(touched.tax_code && errors.tax_code)}
                        className="input-no-fieldset"
                        fullWidth
                        helperText={touched.tax_code && errors.tax_code}
                        margin="normal"
                        name="tax_code"
                        size="small"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.tax_code}
                        variant="outlined"
                        placeholder="Nhập mã số thuế"
                      />
                    </Grid>
                  </>
                )}
                <Grid item md={6} xs={12}>
                  <InputLabel>
                    {values.type === 'user' ? 'Mật khẩu' : 'Tạo mật khẩu'} <span style={{ color: 'red' }}> *</span>{' '}
                  </InputLabel>

                  <TextField
                    error={Boolean(touched.password && errors.password)}
                    fullWidth
                    helperText={touched.password && errors.password}
                    margin="normal"
                    className="input-no-fieldset"
                    name="password"
                    type={showPassword ? 'text' : 'password'}
                    size="small"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.password}
                    placeholder="Nhập mật khẩu"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={() => setShowPassword(prev => !prev)}
                          >
                            {showPassword ? (
                              <VisibilityOff style={{ color: '#D9042F' }} />
                            ) : (
                              <Visibility style={{ color: '#D9042F' }} />
                            )}
                          </IconButton>
                        </InputAdornment>
                      )
                    }}
                    variant="outlined"
                  />
                </Grid>
                <Grid item md={6} xs={12}>
                  <InputLabel>
                    Xác nhận lại mật khẩu{' '}
                    <span style={{ color: 'red' }}> *</span>
                  </InputLabel>
                  <TextField
                    error={Boolean(
                      touched.confirm_password && errors.confirm_password
                    )}
                    fullWidth
                    helperText={
                      touched.confirm_password && errors.confirm_password
                    }
                    margin="normal"
                    name="confirm_password"
                    className="input-no-fieldset"
                    type={showConfirmPassword ? 'text' : 'password'}
                    size="small"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.confirm_password}
                    placeholder="Xác nhận lại mật khẩu"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={() =>
                              setShowConfirmPassword(prev => !prev)
                            }
                          >
                            {showConfirmPassword ? (
                              <VisibilityOff style={{ color: '#D9042F' }} />
                            ) : (
                              <Visibility style={{ color: '#D9042F' }} />
                            )}
                          </IconButton>
                        </InputAdornment>
                      )
                    }}
                    variant="outlined"
                  />
                </Grid>
              </Grid>
              <Box my={3}>
                <div className={classes.groupButtonSubmit}>
                  <div className={classes.wrapper}>
                    <Button
                      style={{
                        ...(isMobile && { maxWidth: 90 }),
                        marginRight: '10px',
                        textTranform: 'none !important'
                      }}
                      onClick={() => onClose()}
                      className="btn-main btn-plain mx-3"
                      color="primary"
                      size="large"
                      variant="contained"
                    >
                      Thoát
                    </Button>
                    <Button
                      style={{
                        ...(isMobile && { maxWidth: 120 }),
                        marginRight: '10px',
                        textTranform: 'none !important'
                      }}
                      className="btn-main mx-3"
                      color="primary"
                      size="large"
                      type="submit"
                      variant="contained"
                    >
                      Thêm mới
                    </Button>
                    {statusCreate === STATUS_API.PENDING && (
                      <CircularProgress
                        size={24}
                        className={classes.buttonProgress}
                      />
                    )}
                  </div>
                </div>
              </Box>
            </form>
          )}
        </Formik>
      </div>
    </CustomDialog>
  );
}

const useStyles = makeStyles(theme => ({
  root: {
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  groupButtonSubmit: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '15px',

    '& .left-button': {
      display: 'flex'
    }
  },
  wrapper: {
    position: 'relative'
  },
  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12
  },
  customOutline: {
    '& .MuiOutlinedInput-notchedOutline': {
      borderWidth: '1px',
      borderColor: 'rgba(31, 31, 31, 0.14)',
      borderRadius: '4px'
    }
  }
}));

export default React.memo(CreateUser);
